// This file was automatically generated from appchart.dialog.rxDownloadFills.html.
// Please don't edit this file by hand.

goog.provide('el8.template.appchart.dialog.rxDownloadFills');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.dialog.rxDownloadFills.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8DialogContainer"><div class="fills-header mt10"></div><div class="fills-content spacer"></div><p class="el8AppText spacer">Note: Certain information may not be available or accurate in this report, including items that the patient asked not be disclosed due to patient privacy concerns, over-the-counter medications, low cost prescriptions, prescriptions paid for by the patient or non-participating sources, or errors in insurance claims information. The provider should independently verify medication history with the patient.</p></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.dialog.rxDownloadFills.groupedFills = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  var groupList2729 = opt_data.groups;
  var groupListLen2729 = groupList2729.length;
  for (var groupIndex2729 = 0; groupIndex2729 < groupListLen2729; groupIndex2729++) {
    var groupData2729 = groupList2729[groupIndex2729];
    output.append('<table class="el8Table"><thead><tr><th>Medication</th><th>Fill Date</th><th>Qty</th><th>Supply</th><th>Prescriber</th></tr></thead>');
    var fillList2731 = groupData2729.fills;
    var fillListLen2731 = fillList2731.length;
    for (var fillIndex2731 = 0; fillIndex2731 < fillListLen2731; fillIndex2731++) {
      var fillData2731 = fillList2731[fillIndex2731];
      el8.template.appchart.dialog.rxDownloadFills.fill(soy.$$augmentData(fillData2731, {summaryIsSignedOff: groupData2729.summaryIsSignedOff}), output);
    }
    output.append('</table>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.dialog.rxDownloadFills.fill = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<tr><td class="el8LargeDescriptionSize">', (! (opt_data.summaryIsSignedOff && (opt_data.isRxDownload || ! opt_data.isRxDownload && opt_data.isDeleted))) ? '<a class="fill-detail-trigger" data-id="' + soy.$$escapeHtml(opt_data.id) + '">' + soy.$$escapeHtml(opt_data.medicationDescription) + '</a>' + ((opt_data.priorAuth) ? '<span class="el8GrayText clearfix">Prior Auth: ' + soy.$$escapeHtml(opt_data.priorAuth) + '</span>' : '') : soy.$$escapeHtml(opt_data.medicationDescription), '</td><td class="el8DateYrMMColumn">', (soy.$$escapeHtml(opt_data.lastFillDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.lastFillDate)) : ''), '</td><td class="el8NumberColumn">', soy.$$escapeHtml(opt_data.quantity ? '#' + opt_data.quantity + ' ' : ''), '</td><td class="el8LargeNumberColumn">', soy.$$escapeHtml(opt_data.daysSupply ? opt_data.daysSupply + ' days' : ''), '</td><td class="el8DescriptionSize">', soy.$$escapeHtml(opt_data.prescriber ? opt_data.prescriber : ''), '</td></tr>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.dialog.rxDownloadFills.header = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.signDate) ? '<p class="el8SignoffText mb10">Signed off by ' + soy.$$escapeHtml(opt_data.signUserName) + ' on ' + (soy.$$escapeHtml(opt_data.signDate)? el8.service.tz.soyDateTime(soy.$$escapeHtml(opt_data.signDate)) : '') + '</p>' : '', '<p class="el8Bold">', soy.$$escapeHtml(opt_data.fillCount), ' medication fills received', (opt_data.reconciledFillCount > 0) ? ', and ' + soy.$$escapeHtml(opt_data.reconciledFillCount) + ' fills reconciled into Meds List' : '', '.</p>', (opt_data.pbmName) ? '<p class="el8GrayText">Source: ' + soy.$$escapeHtml(opt_data.pbmName) + '</p>' : '');
  if (!opt_sb) return output.toString();
};
